import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ProjectTemplate } from '.';

export interface LoadingStatus {
    serverRequestInProgress: boolean;
    loaded: boolean;
}

export interface State extends EntityState<ProjectTemplate>, LoadingStatus {
    completixTemplatesLoading: boolean;
}

export const adapter: EntityAdapter<ProjectTemplate> = createEntityAdapter<ProjectTemplate>();

export const initialState: State = adapter.getInitialState({
    serverRequestInProgress: false,
    loaded: false,
    completixTemplatesLoading: false,
});
